import React from 'react';
import { Star } from '../star/star';
import * as styles from './star-rating.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
export function StarRating(_ref) {
  var _ref$fillBackground = _ref.fillBackground,
    fillBackground = _ref$fillBackground === void 0 ? 'none' : _ref$fillBackground,
    _ref$fillStar = _ref.fillStar,
    fillStar = _ref$fillStar === void 0 ? styles.FILL_COLOR : _ref$fillStar,
    rating = _ref.rating,
    _ref$maxRating = _ref.maxRating,
    maxRating = _ref$maxRating === void 0 ? 5 : _ref$maxRating,
    _ref$starSize = _ref.starSize,
    starSize = _ref$starSize === void 0 ? 20 : _ref$starSize,
    _ref$starGap = _ref.starGap,
    starGap = _ref$starGap === void 0 ? 1 : _ref$starGap,
    _ref$strokeColor = _ref.strokeColor,
    strokeColor = _ref$strokeColor === void 0 ? styles.FILL_COLOR : _ref$strokeColor,
    _ref$strokeWidth = _ref.strokeWidth,
    strokeWidth = _ref$strokeWidth === void 0 ? 5 : _ref$strokeWidth;
  var getRatingPercents = () => {
    var adjustedFinalRating = Math.min(maxRating, Math.max(rating, 0));
    var totalFullStars = Math.floor(adjustedFinalRating);
    var starFraction = adjustedFinalRating % 1 === 0 ? 0 : adjustedFinalRating % 1 * 100;
    return [...Array(totalFullStars).fill(100), starFraction, ...Array(maxRating).fill(0)].slice(0, maxRating);
  };
  return ___EmotionJSX("div", {
    css: styles.starRating(starGap)
  }, getRatingPercents().map((percentage, index) => ___EmotionJSX("span", {
    css: styles.starWrapper,
    key: index
  }, ___EmotionJSX(Star, {
    fillBackground: fillBackground,
    percentage: percentage,
    fillStar: fillStar,
    size: starSize,
    strokeColor: strokeColor,
    strokeWidth: strokeWidth
  }))));
}